import React, {Component} from 'react';
import {connect} from "react-redux";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import RadioSingleItem from "../radioSingleItem/radioSingleItem";
import PortraitImg from "../../static/assets/img/item/portrate.jpg";
import LandscapeImg from "../../static/assets/img/item/land-scape-img.jpg";
import {imageUrl} from '../../api';
import AudioPlayer from "../player/AudioPlayer";

import {getPlaylist} from "../../redux/actions/playlist/index";

class Archive extends Component {

    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }

    next() {
        this.slider.slickNext();
    }

    previous() {
        this.slider.slickPrev();
    }

    playlist = async (program_type_id, content_id) => {
        await this.props.dispatch(getPlaylist(program_type_id, content_id));
    };



    render() {
        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false
        };
        const {programInfo, language_detector, playlist} = this.props;
        const play_list = playlist.data;
        const current_index = playlist.current_index;
        return (
            <div>
                {programInfo && programInfo.map((program, i) =>
                    i % 2 ?

                        <div className="secPad morningLive bgWhite" key={i}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-12">
                                        <h3 className="secTitle">{language_detector === 'us' ? program.program_name : program.program_name_bangla}</h3>
                                        <div className="arrowBtn">
                                            <button className="cusSlickPrev" onClick={this.previous}><i
                                                className="flaticon-left-arrow"></i></button>
                                            <button className="cusSlickNext" onClick={this.next}><i
                                                className="flaticon-next"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <Slider className="row landscapeSlider"
                                                ref={c => (this.slider = c)} {...settings}>
                                            {
                                                program.items.length > 0 && program.items.map((item, j) =>
                                                    <div className="col sliderItem" key={j}>
                                                        <div onClick={() => this.playlist(item.program_type_id, item.id)}>
                                                            <RadioSingleItem
                                                                itemImg={item.img_web_landscape ? imageUrl + item.img_web_landscape : LandscapeImg}
                                                                itemTitle={language_detector === 'us' ? item.title : item.title_in_bangla}
                                                                premium={item.premium}/>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="secPad morningLive bgGray" key={i}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-12">
                                        <h3 className="secTitle">{language_detector === 'us' ? program.program_name : program.program_name_bangla}</h3>
                                        <div className="arrowBtn">
                                            <button className="cusSlickPrev" onClick={this.previous}>
                                                <i className="flaticon-left-arrow"></i>
                                            </button>
                                            <button className="cusSlickNext" onClick={this.next}>
                                                <i className="flaticon-next"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <Slider className="row portraitSlider"
                                                ref={c => (this.slider = c)} {...settings}>
                                            {
                                                program.items.length > 0 && program.items.map((item, j) =>
                                                    <div className="col sliderItem" key={j}>
                                                        <div onClick={() => this.playlist(item.program_type_id, item.id)}>
                                                        <RadioSingleItem
                                                            itemImg={item.img_web_portrait ? imageUrl + item.img_web_portrait : PortraitImg}
                                                            itemTitleBottom={language_detector === 'us' ? item.title : item.title_in_bangla}
                                                            premium={item.premium}/>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                )}
                {
                    play_list&&
                    <AudioPlayer play_list={play_list} current_index={current_index} />
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    language_detector: state.language_detector,
    playlist: state.playlist
});

export default connect(mapStateToProps)(Archive);